<template>
  <el-container style="height: 100%">
    <el-header
      style="padding: 0px;box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);z-index: 1;"
      :height="headerHeight"
    >
      <el-menu
        class="_layout-header my-head-menu"
        router
        mode="horizontal"
        ref="elHeader"
      >
        <el-menu-item
          v-for="m in $store.state.user.routers.slice(0, maxShowHeaderMenu)"
          :index="reback(m)"
          :key="m.meta.id"
          class="big-menu"
          :class="m.path==modulePath?'curr':''"
        >
          {{ m.meta.title }}
        </el-menu-item>
        <el-submenu
          index="/more"
          v-if="$store.state.user.routers.length > maxShowHeaderMenu"
        >
          <template slot="title">更多</template>
          <el-menu-item
            v-for="m in $store.state.user.routers.slice(maxShowHeaderMenu)"
            :index="m.path"
            :key="m.meta.id"
          >
            {{ m.meta.title }}
          </el-menu-item>
        </el-submenu>
        
        <el-submenu index="/my" class="head-rgt">
          <template slot="title">{{ $store.state.user.name }}</template>
          <!-- <el-menu-item index="/my/setting" >配置</el-menu-item> -->
          <el-menu-item index="" @click="logout">注销</el-menu-item>
        </el-submenu>

        <el-submenu index="" class="head-rgt">
          <template slot="title">皮肤切换</template>
          <el-menu-item index="" @click="checkTheme('polarNightBlue')">极夜蓝</el-menu-item>
          <el-menu-item index="" @click="checkTheme('moonLightWhite')">月光白</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-header>
    <el-container
      v-if="
        modulePath == '/gis' ||
        modulePath == '/video' ||
        modulePath == '/videoMonitoring' ||
        modulePath == '/baojing' ||
        modulePath == '/baojing_th' ||
        modulePath == '/columnBroadcast' ||
        modulePath == '/gas' ||
        modulePath == '/bswScreen' ||
        modulePath == '/xixun_iframe' ||
        modulePath == '/kalaite_iframe' ||
        modulePath == '/yangbang_iframe' ||
        modulePath == '/chargeNeoFrame' ||
        modulePath == '/chargePileFrame' ||
        modulePath == '/AiVideo' ||
        modulePath == '/soil' ||
        modulePath == '/jk' ||
        modulePath == '/ap'
      "
      class="main_box"
    >
      <el-container>
        <router-view />
      </el-container>
    </el-container>
    <el-container v-else class="box_right">
      <el-aside
        class="my-aside"
        style="width: 200px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);z-index: 1"
      >
        <el-scrollbar class="_scroll">
          <el-menu
            class="_layout-nav"
            :default-active="$route.path"
            :default-openeds="openedMenus"
            router
            ref="menu"
            style="border: none"
          >
            <el-menu-tree
              v-for="menu in $store.state.user.routers"
              v-show="modulePath&&menu.path == modulePath"
              :menus="menu.children || []"
              :key="menu.path"
            ></el-menu-tree>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container>
        <el-main class="my-el-main">
          <el-breadcrumb separator="/">
            <template v-for="m in $route.matched">
              <el-breadcrumb-item
                v-if="!m.meta.menuHide"
                :key="m.meta.id"
                :to="m.path"
              >
                {{ m.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
          <div class="h20"></div>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
import ElMenuTree from "@/components/common/elMenuTree";
import systemApi from "@/api/auth/system";
export default {
  components: { ElMenuTree },
  data() {
    return {
      operationDialog: false,
      contactDialog: false,
      headerHeight: "60px",
      openedMenus: [],
      currentMenus: [],
      menuPath: "",
      maxShowHeaderMenu: 0
    };
  },
  computed: {
    modulePath() {
      let e =
        this.$route.matched.length == 0
          ? this.$route.path
          : this.$route.matched[0].path;
      return e ? e : "/";
    },
  },
  
  beforeRouteEnter(to, from, next) {
    next();
  },
  mounted() {
    this.resize();
    // console.log('mounted',111)
    window.addEventListener("resize", this.resize);
  },
  created() {
    let meta = document.getElementsByTagName("meta");
    meta[1].content = "";
    this.maxShowHeaderMenu = Math.floor(document.body.clientWidth / 110) - 3;
    window.addEventListener('popstate', this.popstate, false);
  },
  methods: {
    popstate() {
      let elItem = document.getElementsByClassName("big-menu is-active")
      if(elItem&&elItem.length){
        elItem[0].classList.remove('is-active')
      }      
    },
    logout() {
      this.$confirm("您确定注销退出系统吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.$store.dispatch("logout");
      });
    },
    reback(m) {
      if(m.children.length>1){
        return m.path+'/'+m.children[1].path
      }
      return m.path
    },
    resize() {
      this.headerHeight = this.$refs.elHeader.$el.clientHeight + "px";
    },
    checkTheme(val) {
      systemApi.setTheme(this.$store.state.user.id,{
        theme: val
      }).then((res) => {
        if(res.data.code==1000){
          document.getElementById("style").setAttribute("href","/static/css/"+val+"/index.css");
          this.$store.commit('SET_SYSTEM_THEME',val);
          let mapStyle = 'light';
          if(val=='polarNightBlue'){
            mapStyle = 'darkblue';
          }
          this.$eventBus.$emit("mapStyle", mapStyle);
        }else{
          return this.$message({
            message: res.message || '错误',
            type: 'error',
            duration: 3 * 1000
          });
        }
      });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
    window.removeEventListener('popstate', this.popstate, false);
  }
};
</script>
<style lang='less'>
._scroll {
  height: 100%;
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
}
.my-head-menu{
  &.el-menu {
    border:0 !important;
    .el-menu-item {
      font-size: 16px;
    }
  }
 
}

.my-aside{
  .el-menu {
    border:0 !important;
    .el-menu-item {
      font-size: 16px;
      padding-left: 40px !important;
    }
  }
}
._layout-nav .el-menu-item:hover, ._layout-nav .el-menu-item.is-active {
	border-right-width: 4px;
}

</style>